import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';

import { formatCurrency } from '../../utils/currency.utils';
import Summary from '../TripInvoice/Summary';
import ChangeAirReceiptCard from './ChangeAirReceiptCard';
import TitleSummaryList from '../tripSummary/TitleSummary';
import { TouchableOpacity } from 'react-native-gesture-handler';
import BaseText from '../BaseText';
import { Color, CommonProperties } from '../../styles';
import Icon from '../Icon';
import RowView from '../RowView';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
const AirChangeSummaryList = ({ response, price, pnr, onChange }) => {
  const lastIndex = response.AirLegs[0].AirSegments.length;
  const fromCity = response.AirLegs[0]?.AirSegments[0]?.DepartAirportCityName;
  const toCity = response.AirLegs[0]?.AirSegments[lastIndex - 1]?.ArrivalAirportCityName;
  const title = `${fromCity} to ${toCity}`;
  const [checkedFlights, setcheckedFlights] = useState({});
  const [checkedFlag, setcheckedFlag] = useState(false);
  const currency = useSelector(selectCompanyCurrency);
  const currencyculture = useSelector(selectCompanyCurrencyCulture);

  const selectFlight = (LegNumber) => {
    setcheckedFlights({
      ...checkedFlights,
      [LegNumber]: !checkedFlights[LegNumber],
    });
  };

  useEffect(() => {
    onChange(checkedFlights);
  }, [checkedFlights, onChange]);

  const selectAll = (type) => {
    const checkedFlights = {};
    response.AirLegs.forEach((airSegment) => {
      checkedFlights[airSegment.LegNumber - 1] = type;
    });
    setcheckedFlights(checkedFlights);
    setcheckedFlag(type);
    onChange(checkedFlights);
  };

  return (
    <>
      <TitleSummaryList
        desc={title}
        amount={formatCurrency(price, currency, currencyculture)}
        iconName="flight"
      />
      <TouchableOpacity
        onPress={() => {
          selectAll(!checkedFlag);
        }}
      >
        <BaseText style={styles.textColor}>{checkedFlag ? 'Unselect All' : 'Select All'}</BaseText>
      </TouchableOpacity>
      <Summary>
        {response.AirLegs &&
          response.AirLegs.map((leg, index) => (
            <RowView key={index}>
              <TouchableOpacity
                style={[
                  styles.checkbox,
                  leg.AirSegments.length === 1 ? styles.singleLegcheckbox : null,
                ]}
                onPress={() => {
                  selectFlight(leg?.LegNumber - 1);
                }}
              >
                {checkedFlights && checkedFlights[index] && (
                  <Icon name="check" style={styles.icon} size={16} color={Color.accent} />
                )}
              </TouchableOpacity>
              <ChangeAirReceiptCard key={leg.LegNumber} item={leg} pnr={pnr} flight={response} />
            </RowView>
          ))}
      </Summary>
    </>
  );
};
const styles = StyleSheet.create({
  textColor: {
    color: Color.primary,
    ...CommonProperties.p4,
    ...CommonProperties.h4,
  },
  icon: {
    backgroundColor: Color.primary,
  },
  checkbox: {
    width: 20,
    height: 20,
    marginVertical: 100,
    ...CommonProperties.mx3,
    borderRadius: 2,
    borderColor: Color.primary,
    borderWidth: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  singleLegcheckbox: {
    marginVertical: 60,
  },
});

export default AirChangeSummaryList;
